import React from "react";
import AppHeading from "../layout/parts/app-heading";
import AppBody from "../layout/parts/app-body";
import DataTable from "../components/data-table/data-table";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import GenericAddDialog from "./components/dialogs/generic-add-dialog";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../providers/auth-provider";
import isAdmin from "../functions/is-admin";
import { v4 as uuid } from "uuid";
import axios from "../requests/axios";

export default function ManageOrganisationsPage() {
  const [showAddOrgDialog, setShowAddOrgDialog] = React.useState(false);
  const tableRef = React.useRef();
  const navigate = useNavigate();
  const { user } = useAuth();

  const columns = React.useMemo(
    () => [
      {
        label: "Organisation Name",
        key: "organisation_name",
        value: "organisation_name",
        width: 50,
      },
      {
        label: "Users",
        key: "users_count",
        value: "users_count",
        width: 15,
      },
      {
        label: "Channels",
        key: "channels_count",
        value: "channels_count",
        width: 15,
      },
      {
        label: "",
        value: "",
        key: "0",
        width: 20,
        renderValue: (row) => {
          return (
            <span className="data-table__action-cell">
              <span
                className="data-table__action-cell__item data-table__icon"
                onClick={() =>
                  navigate(`/admin/organisations/${row.organisation_id}`)
                }
              >
                <EditRoundedIcon />
              </span>
            </span>
          );
        },
      },
    ],
    [navigate]
  );

  // admin-only page
  if (!isAdmin(user)) {
    navigate("/");
    return;
  }

  function openNewOrgDialog() {
    setShowAddOrgDialog(true);
  }

  function closeNewOrgDialog() {
    setShowAddOrgDialog(false);
  }

  function refreshTable() {
    tableRef.current?.refreshList();
  }

  function createOrganisation(payload) {
    return axios.post(`api/organisations`, payload);
  }

  return (
    <React.Fragment>
      <AppHeading
        title="Manage Organisations"
        subtitle="Add Organisations using the button on the top right"
        rightActions={[
          {
            onClick: openNewOrgDialog,
            balloonLabel: "Add user",
            icon: AddCircleRoundedIcon,
          },
        ]}
      />

      <AppBody>
        <div className="organisations-page">
          <DataTable
            url={"/api/organisations"}
            columns={columns}
            ref={tableRef}
          />
        </div>
      </AppBody>
      <GenericAddDialog
        onSubmit={createOrganisation}
        onSuccess={() => refreshTable()}
        onClose={closeNewOrgDialog}
        isOpen={showAddOrgDialog}
        title="Add New Organisation"
        successMessage="Organisation created successfully"
        errorMessage="Error occurred while creating Organisation"
        fields={[
          {
            type: "text",
            label: "Organisation Name",
            name: "organisation_name",
            required: true,
          },
        ]}
        key={`add-dialog-${uuid()}`}
      />
    </React.Fragment>
  );
}
